module.exports = __webpack_public_path__ + "static/media/hero-bg.4132f24f.jpg";